export const VIDEO_CATEGORIES = [
  "Anal",
  "Body Hair",
  "Feet",
  "Kissing",
  "Latex",
  "Cum",
  "Nipples",
  "Piercing",
  "Role Play",
  "Spanking",
  "S & M",
  "Socks",
  "Tickling",
  "Wrestling",
  "Armpits",
  "Bears",
  "Fisting",
  "Foreskin",
  "Jocks",
  "Leather",
  "Muscle",
  "PNP",
  "Rimming",
  "Shaving",
  "Smoking",
  "Tattoos",
  "Verbal",
  "WS",
  "Oral",
  "Daddy",
  "Twinks",
  "Groups",
  "Bondage",
  "Toys",
  "Dirty",
  "Worship",
  "Poppers",
  "Fag",
  "Bareback",
  "Domination",
  "Submission",
  "Fetish",
  "Edging",
  "JOI",
  "Voyeur",
];

export function normalizeVideoTagsForDisplay(value) {
  const entries = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split(/[,;]/)
      : [];

  return entries
    .filter(entry => typeof entry === "string" || typeof entry === "number")
    .map(entry => String(entry).trim())
    .filter(Boolean);
}

export function getVideoCategories(value) {
  const selected = new Set(normalizeVideoTagsForDisplay(value));
  return VIDEO_CATEGORIES.filter((category) => selected.has(category));
}